<template>
  <div class="platform-content-viewer" v-loading="loading">
    <el-alert
      v-if="item.detailWarning"
      type="warning"
      :closable="false"
      show-icon
      class="viewer-warn"
      :title="item.detailWarning"
    />
    <component :is="viewerComp" :item="item" />
    <div v-if="showFooter" class="viewer-footer">
      <el-link
        v-if="item.noteUrl"
        :href="item.noteUrl"
        target="_blank"
        type="primary"
      >打开原文</el-link>
      <span v-else class="text-muted">无原文链接</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import XhsNoteViewer from './XhsNoteViewer.vue'
import DouyinVideoViewer from './DouyinVideoViewer.vue'
import ZhihuArticleViewer from './ZhihuArticleViewer.vue'
import GenericWorkViewer from './GenericWorkViewer.vue'

const props = defineProps({
  item: { type: Object, required: true },
  loading: { type: Boolean, default: false },
  showFooter: { type: Boolean, default: true },
})

const viewerComp = computed(() => {
  const p = (props.item?.platform || '').toLowerCase()
  if (p === 'xiaohongshu') return XhsNoteViewer
  if (p === 'douyin') return DouyinVideoViewer
  if (p === 'zhihu') return ZhihuArticleViewer
  return GenericWorkViewer
})
</script>

<style scoped>
.platform-content-viewer { min-height: 120px; }
.viewer-warn { margin-bottom: 12px; }
.viewer-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  padding-top: 8px;
}
.text-muted { color: #c0c4cc; font-size: 13px; }
</style>
